var _style, _polygon, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrailerBlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.9 15.4",
    style: {
      enableBackground: "new 0 0 21.9 15.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#3D66B0;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2.5,1.7 2.5,8.5 4.2,8.5 4.2,2.5 5.8,2.5 5.8,8.5 7.5,8.5 7.5,2.5 9.2,2.5 9.2,8.5 10.7,8.5 10.7,2.5  12.4,2.5 12.4,8.5 14.1,8.5 14.1,2.5 15.8,2.5 15.8,8.5 17.5,8.5 17.5,1.7 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.2,0H0.8v10.2h18.4C19.2,10.2,19.2,0,19.2,0z M15.8,8.5v-6h-1.7v6h-1.7v-6h-1.7v6H9.2v-6H7.5v6H5.8v-6H4.2v6 H2.5V1.7h15v6.8H15.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.5,10.8v-0.6h-1v0.6H4.4v-0.6h-1v0.6H0.8v0.7v0.3v0.5v0.1v0.8h1.8c0,1.1,0.9,2,2,2s2-0.9,2-2h0.3 c0,1.1,0.9,2,2,2s2-0.9,2-2h0.4v0.7V14v0.4c0,0.1,0.1,0.2,0.2,0.2h3.2c0.1,0,0.2-0.1,0.2-0.2V14l0,0l0,0v-0.7h0.4v-0.9h-4.7 c-0.1-0.2-0.2-0.4-0.4-0.5h10.2v2.7h0.9v-2.7v-0.5v-0.5h-5.8V10.8z M12.1,13.1H14v0.5h-1.9V13.1z M2.8,12.3H1.7v-0.5h1.5 C3,11.9,2.9,12.1,2.8,12.3z M4.6,14c-0.5,0-0.9-0.4-0.9-0.9c0-0.4,0.2-0.7,0.6-0.9c0.1,0,0.2-0.1,0.3-0.1s0.2,0,0.3,0.1 c0.3,0.1,0.6,0.5,0.6,0.9C5.5,13.6,5.1,14,4.6,14z M7.1,12.3H6.4c-0.1-0.2-0.2-0.4-0.4-0.5h1.5C7.3,11.9,7.2,12.1,7.1,12.3z  M8.8,14c-0.5,0-0.9-0.4-0.9-0.9c0-0.4,0.2-0.7,0.6-0.9c0.1,0,0.2-0.1,0.3-0.1s0.2,0,0.3,0.1c0.3,0.1,0.6,0.5,0.6,0.9 C9.8,13.6,9.4,14,8.8,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.6,12.8c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4S5,13.3,5,13.1S4.8,12.8,4.6,12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.8,12.8c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4S9,12.8,8.8,12.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerBlIcon);
export default __webpack_public_path__ + "static/media/trailer-bl-icon.ec88f3b855e7975dbaffa5fd28e70e10.svg";
export { ForwardRef as ReactComponent };